import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FGrid, FGridMoneyCell } from '../grid';

type Props = {
  rows: any[];
  loading?: boolean;
};

class BudgetVersionLinesGrid extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'sourcecode', headerName: 'Source', width: 120 },
    { field: 'costcentercode', headerName: 'Cost Center', width: 130 },
    { field: 'costcentername', headerName: 'Cost Center Name', flex: 1, minWidth: 250 },
    { field: 'accountcode', headerName: 'Account', width: 120 },
    { field: 'accountname', headerName: 'Account Name', flex: 1, minWidth: 250 },
    { field: 'lineitem', headerName: 'Line Item', flex: 1, minWidth: 250 },
    { field: 'amount', headerName: 'Amount', width: 150, renderCell: FGridMoneyCell },
    { field: 'approvedamount', headerName: 'Approved', width: 150, renderCell: FGridMoneyCell },
  ];

  render() {
    return (
      <FGrid
        title="Budget Version Lines"
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={500}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#e7f6ea' }}
        getRowId={(row: any) => row.rid || row.id}
        pageSizeOptions={[25, 50, 100]}
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
      />
    );
  }
}

export default BudgetVersionLinesGrid;
